import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'store/hooks/useSelector'
import { HOME_PAGE_PATH } from 'utils/constants'
import { Navigation } from './Navigation'

type Props = {
  children: React.ReactNode
}

export function PageLayout({ children }: Props) {
  const navigate = useNavigate()
  const isLoggedIn = useSelector((state) => state.auth.accessToken)

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(HOME_PAGE_PATH)
    }
  }, [isLoggedIn, navigate])

  return (
    <div style={{ display: 'grid', gridTemplateColumns: '160px auto', height: '100vh' }}>
      <Navigation />
      <div style={{ background: '#ECEFF1', overflowY: 'scroll', padding: '48px' }}>{children}</div>
    </div>
  )
}
